import UploadButton from 'volto-base-addon/components/manage/Blocks/UploadButton/UploadButton';
import { Button } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { EPIC_LIVE_STREAM } from 'volto-m4-theme-addon/constants';
import { useIntl } from 'react-intl';
import { startEpic } from 'volto-epics-addon/helpers';
import { messages } from 'volto-m4-theme-addon';

const View = ({ path, content }) => {
  const user = useSelector((state) => state.users.user);
  const intl = useIntl();

  const liveButtonHandler = () => {
    // Let's start a new live stream process!
    let destinationPath = path;
    startEpic(EPIC_LIVE_STREAM, {
      destinationPath: destinationPath,
    });
  };

  return (
    <UploadButton path={path} title={content.title}>
      {user?.roles?.includes('Manager') ? (
        <Button onClick={liveButtonHandler} color="blue">
          {intl.formatMessage(messages.startLiveStream)}
        </Button>
      ) : (
        <></>
      )}
    </UploadButton>
  );
};

export default View;
